import { useAuth } from '../store/auth.store'
import { useAgent } from '../store/agent.store'

/**
 * True when the session should see every area and every feature of the account.
 *
 * Two ways to earn it: the customer's own owner contact, or an agent who has
 * stepped into the customer — agents hold every permission by decision.
 *
 * This exists because the area dropdowns filter `data` by the signed-in row's
 * areaPermissions, and an impersonated row almost never has any: only ~15% of
 * customers have an owner row, and area_permission holds 27 rows in the whole
 * database. Filtering an agent's session by that emptied the list completely.
 */
export const useFullAccess = (): boolean => {
  const { user } = useAuth()
  const { impersonating } = useAgent()

  return Boolean(user?.isOwner) || Boolean(impersonating)
}
